import PropTypes from 'prop-types';
import { ReactstrapNavItem as NavItem, ReactstrapNavLink as NavLink } from '@febos-io/design';
import NavbarUser from './NavbarUser';

import ThemeToggler from './ThemeToggler';
import Icon from '../../../../../components/Icon';

function ThemeNavbar({ skin, setSkin, setMenuVisibility }) {
  return (
    <>
      <div className="bookmark-wrapper d-flex align-items-center">
        <ul className="navbar-nav d-xl-none">
          <NavItem className="mobile-menu me-auto">
            <NavLink
              className="nav-menu-main menu-toggle hidden-xs is-active"
              onClick={() => setMenuVisibility(true)}
            >

              <Icon
                icon="fa-bars"
                className="ficon"
              />
            </NavLink>
          </NavItem>
        </ul>
        <NavItem className="d-none d-lg-block">
          <NavLink className="nav-link-style">
            <ThemeToggler
              skin={skin}
              setSkin={setSkin}
            />
          </NavLink>
        </NavItem>
      </div>
      <NavbarUser
        skin={skin}
        setSkin={setSkin}
      />
    </>
  );
}

ThemeNavbar.propTypes = {
  skin: PropTypes.string.isRequired,
  setSkin: PropTypes.func.isRequired,
  setMenuVisibility: PropTypes.func.isRequired
};
export default ThemeNavbar;
